import React, { useState } from 'react';
import { StyledGalleryProds } from './StyledGalleryProds';
import gsap from 'gsap';

const GalleryProds = ({ imgs  }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  const [source, setSource] = useState(null)

  const handleZoom = (src) => {

    const overlay = document.querySelector('.overlay--zoom')
    if(!isOverlayOpen){
     
      setSource(src.imageLarge);
      setIsOverlayOpen(true)
      gsap.set(".overlay--zoom", {display: "block"})
      gsap.to(overlay,{autoAlpha: 1, ease: "power2.easeInOut", duration: .75})
    }
    
  }

  const handleClose = () => {
    const overlay = document.querySelector('.overlay--zoom')
    
    gsap.to(overlay,{autoAlpha: 0, ease: "power2.easeInOut", duration: .75, onComplete: () => {
      setSource("");
      setIsOverlayOpen(false)
      gsap.set(".overlay--zoom", {display: "none"})
    }})
  }

  

  return (
    <React.Fragment>
      {
       
          <StyledGalleryProds>
            <div className="gallery--wrap">
              <div className="gallery--col gallery--col-big">
                <div className="gallery-img-wrap">
                  <p className="base mobile-tap">Tap the image to experience more</p>
                  <img className="cursor-view" src={imgs[0].thumb} onClick={() => handleZoom(imgs[0])}/>
                </div>
              </div>
              <div className="gallery--col gallery--col-double">
                <div className="gallery-img-wrap">
                  <p className="base mobile-tap">Tap the image to experience more</p>
                  <img className="cursor-view" src={imgs[1].thumb} onClick={() => handleZoom(imgs[1])}/>
                </div>
                <div className="gallery-img-wrap">
                  <p className="base mobile-tap">Tap the image to experience more</p>
                  <img className="cursor-view" src={imgs[2].thumb} onClick={() => handleZoom(imgs[2])}/>
                </div>
                
              </div>
            </div>
            <div className="overlay--zoom" >
              <div className="close--overlay" onClick={handleClose}>
                <img src={require('../../assets/close-overlay.png')} />
              </div>
              <div className="video--holder">
                {
                  (source !== null && source !== "") &&
                  <video muted autoPlay controls>
                    <source src={source} type="video/mp4"></source>
                  </video>
                }
              </div>
              
            </div>
          </StyledGalleryProds>
          
      }
    </React.Fragment>
  );
};

export default GalleryProds;
